import { render } from "./siguientesCitasLista.vue?vue&type=template&id=3c8c8541"
import script from "./siguientesCitasLista.vue?vue&type=script&lang=js"
export * from "./siguientesCitasLista.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__